export default __webpack_public_path__ + "static/media/mail.32c4d76e.svg";